import i18n from 'src/i18n';

export const formatBytes = (bytes) => {
	const value = Number(bytes) || 0;

	const sizes = [
		i18n.t('storageQuota.bytes'),
		i18n.t('storageQuota.kb'),
		i18n.t('storageQuota.mb'),
		i18n.t('storageQuota.gb'),
		i18n.t('storageQuota.tb'),
	];

	if (value === 0) return `0 ${sizes[0]}`;

	const k = 1024;
	const index = Math.min(Math.floor(Math.log(value) / Math.log(k)), sizes.length - 1);

	return `${Math.round((value / Math.pow(k, index)) * 100) / 100} ${sizes[index]}`;
};

export default formatBytes;
